// function to act as a class
const maxValueValidEditor = function maxValueValidEditor() {};

// gets called once before the renderer is used
maxValueValidEditor.prototype.init = function init(params) {
  this.inError = false;

  // Create the tooltip which will contain the error.
  this.errorTooltip = document.createElement('div');
  this.errorTooltip.innerHTML = [
    'This value may not exceed the',
    '<strong>Screening Mammography</strong>',
    'total',
  ].join(' ');
  this.errorTooltip.classList.add('error-tooltip');

  // Attach the tooltip to the row - removed when editing is finished
  // by ag-grid
  params.eGridCell.parentNode.appendChild(this.errorTooltip);

  // Get Max Value to validate against
  const maxValueAllowed =
    +params.api.rowModel.rowsToDisplay[0].data[params.column.colId];

  // create the cell
  this.eInput = document.createElement('input');
  this.eInput.classList.add('ag-cell-edit-input');
  this.eInput.value = params.value;

  // On input, we check the value and row
  // if NaN, empty, or on first row, we set cancel
  this.eInput.addEventListener('input', () => {
    const cellLeft = +params.eGridCell.style.left.replace('px', '');
    const cellWidth = params.eGridCell.getBoundingClientRect().width;
    if (
      isNaN(this.eInput.value) ||
      0 === this.eInput.value.trim().length
    ) {
      this.cancelAfterEnd = true;
      return; // Handled in after cell edit event
    }

    if (0 === params.node.childIndex) {
      this.cancelAfterEnd = false;
      return;
    }

    if (+this.eInput.value > maxValueAllowed) {
      params.eGridCell.classList.add('field-error');
      this.eInput.classList.add('field-error');
      this.cancelAfterEnd = true;
      this.errorTooltip.style.left = `${cellLeft + cellWidth}px`;
      this.errorTooltip.classList.add('visible');
    } else {
      params.eGridCell.classList.remove('field-error');
      this.eInput.classList.remove('field-error');
      this.cancelAfterEnd = false;
      this.errorTooltip.classList.remove('visible');
    }
  });
};

// gets called once when grid ready to insert the element
maxValueValidEditor.prototype.getGui = function getGui() {
  return this.eInput;
};

// focus and select can be done after the gui is attached
maxValueValidEditor.prototype.afterGuiAttached = function afterGuiAttached() {
  this.eInput.focus();
  this.eInput.select();
};

// returns the new value after editing
maxValueValidEditor.prototype.getValue = function getValue() {
  return this.eInput.value;
};

maxValueValidEditor.prototype.isCancelAfterEnd = function isCancelAfterEnd() {
  return this.cancelAfterEnd;
};

maxValueValidEditor.prototype.destroy = function destroy() {
  if (this.errorTooltip.parentNode) {
    this.errorTooltip.parentNode.removeChild(this.errorTooltip);
  }
};

export default maxValueValidEditor;



// WEBPACK FOOTER //
// ./app/config/maxValueValidEditor.js